import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { renderInputs, businessNameInput, streetAndCityInputs, stateAndZipcodeInputs, registeredAgentOmitInput, } from "./utils";
import { useSubmit } from "module/common/components/forms";
import { putBusiness } from "module/main/store/appEndpoints/api";
var Business = function (_a) {
    var formSubmitCallBack = _a.formSubmitCallBack, formRef = _a.formRef;
    var handleSubmit = useSubmit(function (request) {
        var street = request.street, city = request.city, state = request.state, zipcode = request.zipcode;
        var atLeastOneAddressField = [street, city, state, zipcode].some(Boolean);
        var curatedPayload = {
            business_lookups: [
                {
                    business_name: request.business_name,
                    omit_registered_agents: request.omit_registered_agents === "on",
                    mailing_address: atLeastOneAddressField
                        ? {
                            street: street || null,
                            city: city || null,
                            state: state || null,
                            zipcode: zipcode || null,
                        }
                        : undefined,
                },
            ],
        };
        formSubmitCallBack(putBusiness, curatedPayload);
    });
    return (_jsxs("form", { onSubmit: handleSubmit, className: "flex flex-col", id: "endpoints-form", ref: formRef, children: [_jsx("h5", { className: "font-bold mb-2", children: "Business lookup:" }), _jsx("div", { className: "form-row", children: renderInputs([businessNameInput]) }), _jsx("div", { className: "form-row", children: renderInputs([registeredAgentOmitInput]) }), _jsx("h5", { className: "font-bold mb-2 inline", children: "Mailing address:" }), _jsx("div", { className: "form-row", children: renderInputs(streetAndCityInputs) }), _jsx("div", { className: "form-row", children: renderInputs(stateAndZipcodeInputs) })] }));
};
export default Business;
